import { useEffect, useState } from 'react'
import { uploadImages } from '../../services/api'

export const useScoolRecord = (creditPath, goToNextScreen, setIsLoading) => {
  const [files, setFiles] = useState([])
  const [filesUploaded, setFilesUploaded] = useState([])
  const [modal, setModal] = useState(false)

  useEffect(() => {
    setFilesUploaded(creditPath?.readSchoolRecord?.map(({ data, ...file }) => ({ url: data, ...file })) || [])
  }, [creditPath])

  const onClickNextScreen = async () => {
    setIsLoading(true)
    const urls = await uploadImages(files, { documentType: 'school-record' })

    goToNextScreen({
      data: [...filesUploaded, ...urls],
    })
  }

  return [onClickNextScreen, files, setFiles, filesUploaded, modal, setModal]
}
